<template>
    <div
        class="flex flex-row pb-2 pr-20 pt-[15px]"
        :class="{
            'border-b border-b-ds-primary-200': withDivider,
            'pl-2': indentationLevel === 0,
            'pl-[18px]': indentationLevel === 1,
            'pl-8': indentationLevel === 2,
        }"
    >
        <div class="flex-1 text-sm">
            <div v-if="label">{{ label }}</div>
            <slot v-if="!checkNotFound">
                <div
                    v-if="!omitCheckText && checkResult?.text"
                    class="text-sm font-bold text-content-primary"
                >
                    {{ checkResult?.text }}
                </div>
            </slot>
        </div>
        <div class="flex w-3/12 flex-row justify-end text-right">
            <slot name="check-result">
                <CheckStateResult
                    v-if="checkResult"
                    class="text-sm font-semibold"
                    :value="checkResult"
                />
            </slot>
        </div>
    </div>
    <CheckErrorList
        v-if="checkResult && !omitErrorList"
        :indentation-level="indentationLevel"
        :value="checkResult"
    />
</template>

<script lang="ts" setup>
import type { CheckResult } from '@/api/interfaces/identity-verification-report.api';
import { CheckResultState } from '@/api/interfaces/identity-verification-report.api';
import { computed } from 'vue';
import CheckErrorList from './CheckErrorList.vue';
import CheckStateResult from './CheckStateResult.vue';

const props = withDefaults(
    defineProps<{
        checkResult?: CheckResult;
        label?: string;
        omitCheckText?: boolean;
        indentationLevel?: number;
        omitErrorList?: boolean;
        withDivider?: boolean;
    }>(),
    {
        omitCheckText: false,
        indentationLevel: 1,
        omitErrorList: false,
        withDivider: true,
    },
);

const checkNotFound = computed(() => {
    return props.checkResult?.state === CheckResultState.NotFound;
});
</script>
